<template>
    <div class="row">
        <div class="col-md-8">
            <p class="el-style attribute-name">Message:</p>
            <div class="message-content">{{ content }}</div>
        </div>
        <div class="col-md-4"></div>
    </div>
</template>

<script>
  export default {
    props: [
      'row'
    ],

    computed: {
      content() {
        return _.get(this.row, 'content');
      },
    },

    methods: {
      //
    },
  }
</script>

